module.exports = {
    updateCartTotals: function (data) {
        if (data.resources) {
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
        }
        $('.ibcDiscountAmount').addClass('d-none');
        $('.shipping-discount').addClass('d-none');
        $('.coupon-discounts').addClass('d-none');
        if (data.totals) {
            $('.shipping-cost').empty().append(data.totals.totalShippingCost);
            $('.shipping-total-cost').empty().append(data.totals.totalShippingCost);
            $('.tax-total').empty().append(data.totals.totalTax);
            $('.grand-total').empty().append(data.totals.grandTotal);
            $('.grand-total-sum').empty().append(data.totals.grandTotal);
            $('.sub-total').empty().append(data.totals.subTotal);
            if (data.totals.ibcDiscountAmount && data.totals.ibcDiscountAmount.formatted) {
                $('.ibcDiscountAmount').removeClass('d-none');
                var discountText = $('.ibcDiscountAmount').data('label');
                $('.order-discount').first().text(discountText.replace('{percentage}', data.totals.discountPercent));
                $('.order-discount-total').empty()
                    .append(data.totals.ibcDiscountAmount.formatted);
            }
            if (data.totals.shippingLevelDiscountTotal.value > 0) {
                $('.shipping-discount').removeClass('d-none');
                $('.shipping-discount-total').empty().append('- ' +
                    data.totals.shippingLevelDiscountTotal.formatted);
            }
            if (data.totals.discounts.length > 0) {
                $('.coupon-discounts').removeClass('d-none');
                $('.coupon-discounts').empty()
                    .append(data.totals.couponDiscountsHtml);
            }
        }

        if (data.cart && data.cart.numItems !== undefined) {
            $('.minicart-quantity').empty().append(data.cart.numItems);
        }

        if (data.actionUrls) {
            $('.delete-coupon-confirmation-btn').attr('data-action', data.actionUrls.removeCouponLineItem);
        }
        if (data.items) {
            data.items.forEach(function (item) {
                if (data.totals.orderLevelDiscountTotal.value > 0) {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                }
                if (item.renderedPromotions) {
                    $('.item-' + item.UUID).empty().append(item.renderedPromotions);
                } else {
                    $('.item-' + item.UUID).empty();
                }
                $('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
                $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
                $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
            });
        }
    }
};